import firebase from 'firebase';
import _ from 'lodash';

export const getTasksCategories = async (id) => {
  const result = [];
  let req = null;

  req = firebase.firestore()
    .collection('projects')
    .doc(id)
    .collection('tasks-categories')
    .orderBy("index", 'asc');

  const data = await req.get();

  data.forEach((subDoc) => {
    const data = subDoc.data();
    result.push({
      label: data.name || '',
      value: subDoc.id,
      id: subDoc.id || null,
    });
  });

  return [..._.orderBy(result, '_data.index', ['desc'])];
};



export const getOptionsTasksCategories = async (id) => {
  const result = [{label: 'Все категории', value: null}];

  const categories = await getTasksCategories(id);

  return [...result, ...categories];
}



// WEBPACK FOOTER //
// ./src/firestore/tasks-categories.js